import type { OrganizationAlert } from '@/shared/hooks/api/regulatoryNews'

export function formatNewsroomAlertDate(
  iso: string | null,
  locale: string
): string | null {
  if (!iso) {
    return null
  }
  try {
    return new Intl.DateTimeFormat(locale, {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    }).format(new Date(iso))
  } catch {
    return null
  }
}

export function formatNewsroomAlertDateTime(
  iso: string | null,
  locale: string
): string | null {
  if (!iso) {
    return null
  }
  try {
    return new Intl.DateTimeFormat(locale, {
      dateStyle: 'medium',
      timeStyle: 'short',
    }).format(new Date(iso))
  } catch {
    return null
  }
}

export function getNewsroomAlertTitle(
  alert: OrganizationAlert,
  fallback: string
): string {
  if (alert.title && alert.title.trim().length > 0) {
    return alert.title
  }
  return alert.externalId || fallback
}
